// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HcpIntakeRequestModel {
    static getAttributeTypeMap() {
        return HcpIntakeRequestModel.attributeTypeMap;
    }
}
HcpIntakeRequestModel.discriminator = undefined;
HcpIntakeRequestModel.additionalProperties = false;
HcpIntakeRequestModel.attributeTypeMap = [
    {
        "name": "patientAccountUpsearch",
        "baseName": "patientAccountUpsearch",
        "type": "EnterpriseCoordinatorAccountUpsearchRequestModel"
    },
];
//# sourceMappingURL=hcpIntakeRequestModel.js.map